import styled from '@emotion/styled';
import media from '@shared/mediaQuery';
const SolutionProcessStyle = styled('div')`
  .solutionprocess {
    &--header {
      margin-left: 20px;
    }
    &--body {
      margin-top: 8px;
      position: relative;
      ${media.mobile} {
        overflow-x: hidden;
      }
    }
    &--prevbutton {
      ${media.mobile} {
        z-index: 2;
        position: absolute;
        bottom: 190px;
        left: 20px;
        transform: rotate(90deg);
        &.disabled {
          display: none;
        }
      }
    }
    &--nextbutton {
      ${media.mobile} {
        z-index: 2;
        position: absolute;
        bottom: 190px;
        right: 16px;
        transform: rotate(-90deg);
        &.disabled {
          display: none;
        }
      }
    }

    &--carouselwrap {
      background-color: #f6f6f6;
      height: 304px;
      padding-top: 14px;
      position: relative;
    }
    &--cloud {
      z-index: 1;
      width: calc(50% - 94px);
      height: 323px;
      opacity: 0.8;
      position: absolute;
      bottom: 0;
      &.left {
        left: 0;
        background: linear-gradient(-90deg, hsla(0, 0%, 100%, 0), #fff 40%, #fff);
      }
      &.right {
        right: 0;
        background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), #fff 40%, #fff);
      }
    }
    &--index {
      width: 17px;
      padding-top: 1.5px;
      height: 15.5px;
      border-radius: 100%;
      font-size: 12px;
      font-family: 'Gilroy-ExtraBold';
      color: #ffffff;
      flex: none;
      display: flex;
      justify-content: center;
      justify-items: center;
      ${media.mobile} {
        background-color: #cfcfcf;
      }
      ${media.desktop} {
        margin: 0 auto;
      }
      &:not(:last-of-type) {
        margin-right: 8px;
      }
      &.active {
        background-color: #ff5500;
      }
      &-wrap {
        ${media.mobile} {
          display: flex;
          width: 90px;
          margin: 0 auto;
        }
      }
    }
    &--list {
      margin-top: 15px;
      ${media.desktop} {
        display: flex;
        margin-top: 40px;
        margin-left: 76px;
      }
    }
    &--item {
      ${media.desktop} {
        width: 180px;
        flex: none;
        margin-right: 40px;
        position: relative;
      }
      &-arrow {
        ${media.desktop} {
          transform: rotate(-90deg);
          position: absolute;
          top: 40px;
          right: -26px;
        }
      }
      &-image {
        width: 180px;
        ${media.mobile} {
          height: 272px;
          margin: 0 auto;
        }
        ${media.desktop} {
          height: 390px;
          margin-top: 58px;
        }
      }
      &-desc {
        font-size: 15px;
        color: #555555;
        font-family: 'Pretendard-Bold';
        line-height: 24px;
        word-break: keep-all;
        text-align: center;
        margin: 12px auto 0;

        ${media.mobile} {
          width: 250px;
        }
        ${media.desktop} {
          width: 155px;
          line-height: 22px;
        }
      }
    }
  }
  .slick-slide {
    ${media.mobile} {
      width: 220px;
    }
  }
`;

export default SolutionProcessStyle;
